import { render } from "./FormRadioButtonsFieldComponent.vue?vue&type=template&id=33c879bb&scoped=true"
import script from "./FormRadioButtonsFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormRadioButtonsFieldComponent.vue?vue&type=script&lang=js"

import "./FormRadioButtonsFieldComponent.vue?vue&type=style&index=0&id=33c879bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c879bb"]])

export default __exports__